// src/services/http.js
const API_BASE =
  (typeof import.meta !== "undefined" && import.meta.env?.VITE_API_BASE?.replace(/\/+$/, "")) ||
  (process.env.REACT_APP_API_BASE && process.env.REACT_APP_API_BASE.replace(/\/+$/, "")) ||
  "http://localhost:5050";

export async function http(path, { method = "GET", token, body } = {}) {
  const res = await fetch(`${API_BASE}${path}`, {
    method,
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    credentials: "include",
    body: body ? JSON.stringify(body) : undefined,
  });

  const ct = res.headers.get("content-type") || "";
  const payload = ct.includes("application/json")
    ? await res.json().catch(() => ({}))
    : {};

  // ✅ Handle HTTP errors
  if (!res.ok) {
    const msg = payload?.error || payload?.message || `HTTP ${res.status}`;
    throw new Error(msg);
  }

  // ✅ Handle "ok:false" even if backend returns 200
  if (payload && typeof payload === "object" && payload.ok === false) {
    const msg = payload?.error || payload?.message || "Request failed";
    throw new Error(msg);
  }

  // ✅ Unwrap { ok:true, data: ... } pattern globally
  if (payload && typeof payload === "object" && "data" in payload) {
    return payload.data;
  }

  return payload ?? {};
}
